import { useState, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";


const Preloader = ({ setLoading }) => {
  const [count, setCount] = useState(0);
  const fadeControls = useAnimation();
  const logoControls = useAnimation();
  const containerControls = useAnimation();
  const countControls = useAnimation();
  const clipControls = useAnimation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev < 100) return prev + 1;
        clearInterval(interval);
        return 100;
      });
    }, 20);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Progress-based clip-path reveal for SVG
    clipControls.start({
      clipPath: `inset(0 ${100 - count}% 0 0)`,
      transition: { duration: 0.05 },
    });

    // Fade in SVG
    logoControls.start({
      opacity: 1,
      transition: { duration: 0.5 },
    });

    // Counter pulsing animation
    countControls.start({
      opacity: [1, 0.8, 1],
      scale: [1, 1.05, 1],
      transition: { duration: 0.3, repeat: Infinity, repeatType: "reverse" },
    });

    // End animation at 100% (swipe-down clip-path)
    if (count === 100) {
      setTimeout(() => {
        // Swipe-down clip-path for container
        containerControls.start({
          clipPath: "inset(100% 0 0 0)",
          transition: { duration: 1.5, ease: "easeInOut" },
        });

        fadeControls.start({
          opacity: 0,
          transition: { duration: 1 },
        });

        logoControls.start({
          opacity: 0,
          transition: { duration: 1 },
        });

        countControls.start({
          opacity: 0,
          transition: { duration: 1 },
        }).then(() => {
          setLoading(false);
        });
      }, 1000);
    }
  }, [count, fadeControls, logoControls, containerControls, countControls, clipControls, setLoading]);

  return (
    <motion.div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#000000",
        zIndex: 9999999,
        padding: isMobile ? "10vw" : "5vw",
      }}
      initial={{ opacity: 1, clipPath: "inset(0 0 0 0)" }}
      animate={containerControls}
    >
      {/* SVG Logo with Progress-Based Clip-Path Mask */}
      <motion.div
        style={{
          width: isMobile ? "70vw" : "40vw",
          maxWidth: "600px",
          height: "auto",
        }}
        initial={{ opacity: 0 }}
        animate={logoControls}
      >
        <motion.img
          src="https://studiomaamangala.com/wp-content/uploads/2025/05/studio.svg"
          alt="Studio Maamangala Logo"
          style={{
            width: "100%",
            height: "auto",
          }}
          initial={{ clipPath: "inset(0 100% 0 0)" }}
          animate={clipControls}
        />
      </motion.div>

      {/* Bottom-Right Progress Counter */}
      <motion.div
        style={{
          position: "absolute",
          bottom: isMobile ? "5vw" : "3vw",
          right: isMobile ? "5vw" : "3vw",
          color: "#FFFFFF",
          fontSize: isMobile ? "8vw" : "4vw",
          fontWeight: "700",
          fontFamily: "'Montserrat', sans-serif",
        }}
        animate={countControls}
      >
        {count}
      </motion.div>
    </motion.div>
  );
};

export default Preloader;